// components/AgentSelection.js - Updated with Enterprise Technologist styling
import React from 'react';
import './AgentSelection.css';

const AgentSelection = ({ onSelectAgent }) => {
  const agents = [
    {
      id: 1,
      name: "Retail Navigator",
      bookId: "retail-experience",
      bookTitle: "Reimagining the Retail Experience: How AI is Transforming the Customer Journey",
      description: "I specialize in AI-driven retail transformation, customer journey optimization, and innovative shopping experiences. Ask me about personalization, omnichannel strategies, or how AI is reshaping brick-and-mortar and online retail environments.",
      avatar: "/avatars/retail.png",
      badgeClass: "badge-retail"
    },
    {
      id: 2,
      name: "Media Maestro",
      bookId: "media-renaissance",
      bookTitle: "The AI-Powered Media Renaissance: Reshaping Content, Engagement, and Operations",
      description: "I'm an expert in how AI is revolutionizing media creation, distribution, and audience engagement. I can discuss content personalization, automated production, predictive analytics, and the future of media consumption across platforms.",
      avatar: "/avatars/media.png",
      badgeClass: "badge-media"
    },
    {
      id: 3,
      name: "Manufacturing Visionary",
      bookId: "manufacturing-lifecycle",
      bookTitle: "Reimagining Manufacturing and Its Life Cycle",
      description: "I focus on AI applications throughout the manufacturing lifecycle, including smart factories, predictive maintenance, supply chain optimization, and sustainable production methods. I can help with Industry 4.0 adoption strategies and digital transformation.",
      avatar: "/avatars/manufacturing.png",
      badgeClass: "badge-manufacturing"
    },
    {
      id: 4,
      name: "Product Strategist",
      bookId: "product-playbook",
      bookTitle: "Product Playbook III",
      description: "I'm your guide to modern product development strategies, with expertise in agile methodologies, user-centered design, feature prioritization, and product lifecycle management. I can help with roadmapping, product metrics, and innovation frameworks.",
      avatar: "/avatars/product.png",
      badgeClass: "badge-product"
    },
    {
      id: 5,
      name: "Payments Innovator",
      bookId: "payments-ai",
      bookTitle: "Not Yet Another Chatbot: Reimagine Payments with AI",
      description: "I specialize in AI-powered payment solutions, fraud detection, customer experience in financial transactions, and the future of digital payments. Ask me about payment innovation, security, compliance, or user experience in fintech.",
      avatar: "/avatars/payments.png",
      badgeClass: "badge-payments"
    },
    {
      id: 6,
      name: "Contact Center Architect",
      bookId: "contact-centers",
      bookTitle: "Beyond the First Ring: AI-Powered Contact Centers",
      description: "I'm an expert in next-generation contact center design, AI-powered customer service, and omnichannel support strategies. I can discuss agent augmentation, sentiment analysis, automated resolution systems, and the human-AI collaboration model.",
      avatar: "/avatars/contact.png",
      badgeClass: "badge-contactcenter"
    }
  ];

  return (
    <div className="agent-selection">
      <div className="selection-header">
        <h1>Choose Your Expert</h1>
        <p>Select an AI specialist to discuss one of the books</p>
      </div>
      
      <div className="agents-grid">
        {agents.map(agent => (
          <div 
            key={agent.id} 
            className="agent-card" 
            onClick={() => onSelectAgent(agent)}
          >
            <div className="industry-badge badge-retail"></div>
            <div className="agent-avatar">
              <img src={agent.avatar} alt={agent.name} />
            </div>
            <h2>{agent.name}</h2>
            <h3>{agent.bookTitle}</h3>
            <p>{agent.description}</p>
            
            {/* Added hover effect similar to book cards */}
            <div className="agent-hover">
              <p>Click to chat with an expert on {agent.bookTitle}</p>
            </div>
            
            {/* Industry badge similar to book cards */}
            <div className={`industry-badge ${agent.badgeClass}`}>
              {agent.bookId.split('-')[0].charAt(0).toUpperCase() + agent.bookId.split('-')[0].slice(1)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgentSelection;